import { useMemo } from "react";
import type { ErrorLike, Koordinaten } from "../../types";
import { useLocationStore } from "./store";
import { locationRounder } from "./util";

export function useLocation() {
  return useLocationStore();
}

export function useCurrentLocation(): {
  location?: Koordinaten;
  accuracy?: number;
  error?: ErrorLike;
  updatedAt?: number;
} {
  const location = useLocation();
  return useMemo(
    () =>
      location.state === "available"
        ? {
            location: location.koordinaten,
            accuracy: location.accuracy,
            updatedAt: location.updatedAt,
          }
        : location.state === "error"
          ? { error: location.error, updatedAt: location.updatedAt }
          : {},
    [location],
  );
}

export function useRoundedLocation(precision: number): Koordinaten | undefined {
  const { location } = useCurrentLocation();
  return location ? locationRounder(precision)(location) : undefined;
}
